import { render, staticRenderFns } from "./product.vue?vue&type=template&id=29a2d82a&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=29a2d82a&prod&lang=less&scoped=true"
import style1 from "./product.vue?vue&type=style&index=1&id=29a2d82a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2d82a",
  null
  
)

export default component.exports